import { TitleColor } from '..';
import Text from '../Text';

const Education2023 = () => (
  <>
    <TitleColor text="Kurser 2023" smallTitle />
    <Text>
      <b>Animal Emotions</b>
      <br />1 års Online Efteruddannelse hos Karolina Westlund (PhD):
      <br />
      <i>
        "Understanding emotions is essential when caring for animals. Thorough theoretical
        understanding and insights will be presented for the 7 CORE-emotions: CARE, GRIEF, PLAY,
        LUST, SEEKING, FEAR og RAGE"
      </i>
    </Text>
    <Text>
      <b>Ken Ramirez</b>
      <br />
      Seminar den 27. oktober: Hvordan vi arbejder med sky og skræmte dyr, samt
      aggressionsbehandling og håndtering
    </Text>
    <Text>
      <b>Karen Frost</b>
      <br />
      Foredrag den 9. oktober: Forventning eller forventningsstress? Lær hunden at håndtere
      forventning, så det ikke udvikler sig til frustration eller anden uønsket adfærd.
    </Text>
    <Text>
      <b>Emily Priestley</b>
      <br />
      Foredrag den 13. september: Reactivity in Herding Breeds. Management, prevention and
      solutions.
    </Text>
  </>
);

export default Education2023;
